import { render } from "./App.vue?vue&type=template&id=2079bb72"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2079bb72&lang=css"

import exportComponent from "D:\\rober\\RobertVS\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__